// removed by extract-text-webpack-plugin
module.exports = {"container":"ContainerBlock__container___1-45SRq","content":"ContainerBlock__content___1Wje6En"};